import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-50 to-gray-100 border-t border-gray-200">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo y Descripción */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_9921f030-6fc5-40ce-b0b0-197018c0336f/artifacts/nk4ggdbk_Logo.png" 
              alt="Renacimiento Maya Yucatán" 
              className="h-16 w-auto"
            />
            <p className="text-sm text-gray-600 leading-relaxed">
              Secretaría de Economía y Trabajo del Estado de Yucatán
            </p>
            <p className="text-xs text-gray-500">
              Gobierno del Estado de Yucatán 2024-2030, México
            </p>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-gray-600">
                <MapPin className="h-5 w-5 text-gray-400 flex-shrink-0 mt-0.5" />
                <span>Calle 59 No. 514 entre 62 y 64, Centro Histórico, Mérida, Yucatán, México</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-600">
                <Phone className="h-5 w-5 text-gray-400" />
                <a href="tel:+9996118760" className="hover:text-gray-900 transition-colors">(999) 6 11 87 60</a>
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-600">
                <Mail className="h-5 w-5 text-gray-400" />
                <a href="mailto:contacto@sety.yucatan.gob.mx" className="hover:text-gray-900 transition-colors">contacto@sety.yucatan.gob.mx</a>
              </li>
            </ul>
          </div>

          {/* Enlaces Rápidos */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">Página</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">Inicio</Link></li>
              <li><Link to="/noticias" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">Noticias</Link></li>
              <li><Link to="/nosotros" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">Quiénes Somos</Link></li>
              <li><Link to="/programas" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">Programas y Servicios</Link></li>
              <li><Link to="/bolsa-trabajo" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">Bolsa de Trabajo</Link></li>
              <li><Link to="/contacto" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">Contacto</Link></li>
            </ul>
          </div>

          {/* Redes Sociales */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">Síguenos</h3>
            <div className="flex items-center gap-4">
              <a 
                href="https://facebook.com/SETY.YUC" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 transition-colors"
              >
                <Facebook className="h-5 w-5" />
                <span>SETY.YUC</span>
              </a>
            </div>
            <div className="mt-6">
              <h4 className="text-xs font-semibold text-gray-700 uppercase tracking-wider mb-3">Sitios de Interés</h4>
              <ul className="space-y-2">
                <li><a href="#" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">Gobierno de Yucatán</a></li>
                <li><a href="#" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">Transparencia</a></li>
                <li><a href="#" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">Decreto SETY</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-center text-xs text-gray-500">
            © 2024-2030 Secretaría de Economía y Trabajo de Yucatán. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;